<template>
    <svg viewBox="0 0 18 15"
         class="fill-current transition-all duration-700 ease-in-out"
         :height="h"
         :width="w">
        <g fill-rule="evenodd" stroke="none" stroke-width="1">
            <g transform="translate(-423.000000, -47.000000)">
                <g transform="translate(423.000000, 47.500000)">
                    <path d="M6,10.2 L1.8,6 L0.4,7.4 L6,13 L18,1 L16.6,-0.4 L6,10.2 Z"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "icon-check",
        props: {
            w: {
                type: Number,
                default: 18
            },
            h: {
                type: Number,
                default: 15
            },
            color: {
                type: String,
                default: "text-white"
            }
        }
    };
</script>
